import {Injectable} from '@angular/core';
import {GridLayoutService} from '@irb-common/interfaces/grid-layout.service';
import {DeleteExternalAccountsDialogComponent} from "@irb/irb-clients/delete-external-accounts-dialog/delete-external-accounts-dialog.component";

@Injectable({
    providedIn: 'root'
})
export class DeleteExternalAccountsDialogGridLayoutService implements GridLayoutService<DeleteExternalAccountsDialogComponent> {
    constructor() {
    }

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs() {
        return [{
            headerName: 'Account Number',
            field: 'accountNumber',
            maxWidth: 200,
            width: 200,
            sort: 'asc'
        },
            {
                headerName: 'Account Name',
                field: 'accountName',
                maxWidth: 610,
                width: 610
            }];
    }

    getAffectedPortfoliosColumnDefs() {
        return [{
            headerName: 'Portfolio',
            field: 'portfolio',
            width:810,
            maxWidth: 810,
            sort: 'asc',
            valueGetter: (node: any) => node.data
        }];
    }
}
